// PlausiblePageviews.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from './plausible';

export function PlausiblePageviews() {
  const location = useLocation();

  useEffect(() => {
    const host = window.location.hostname;
  
    let appId = 'root';
  
    if (host === 'localhost') {
      appId = 'local';
    } else {
      const parts = host.split('.');
      if (parts.length > 2) {
        appId = parts[0]; // first subdomain (e.g. "app")
      }
    }
  
    const path = location.pathname + location.search;
  
    const virtualPath = `/${appId}${path}`;
  
    trackPageview(virtualPath);
  }, [location]);

  return null;
}